import React from "react";
import { CalendarView } from "./Meals";
export default function Coaching() {
  return <CalendarView kind="coaching" title="Coaching" heading="A daily session for the month's theme" />;
}
